<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <transition>
      <keep-alive>
        <router-view class="Router"/>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* .Router {
  position: absolute;
  width: 100%;
  transition: all .8s ease;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue